import {Injectable} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';

import {IAuthData} from 'src/app/models/IAuthData';
import {IAppState} from 'src/app/models/IAppState';

import {Store} from '@ngrx/store';
import {catchError} from 'rxjs/operators';
import {EMPTY, Observable, throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class InstantChatErrorInterceptor implements HttpInterceptor {
  private authData$: Observable<IAuthData> = this.store.select((state) => state.AppStateReducer.authData);
  private instantLogin: boolean;
  private sessionExpiredAlertOpen = false;

  constructor(
    private alertController: AlertController,
    private translate: TranslateService,
    private store: Store<{ AppStateReducer: IAppState }>,
  ) {
    this.authData$.subscribe((authData: IAuthData) => {
      this.instantLogin = authData?.instantLogin || false;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && this.instantLogin) {
          this.showSessionExpiredError();
          return EMPTY;
        }
        return throwError(() => err);
      })
    );
  }

  private async showSessionExpiredError() {
    if (this.sessionExpiredAlertOpen) {
      return;
    }
    this.sessionExpiredAlertOpen = true;

    try {
      const confirm = await this.alertController.create({
        header: this.translate.instant('Session expired'),
        message: this.translate.instant('Please reopen the sms with the link and click it to reopen the instant chat.'),
        buttons: [{
          text: this.translate.instant('Ok'),
          cssClass: 'secondary',
        }]
      });

      await confirm.present();
      await confirm.onDidDismiss();
    } finally {
      this.sessionExpiredAlertOpen = false;
    }
  }
}
